
import { environment } from '@/environments/environment';

export const MQTT_CONSTANTS = {
    TOPIC_PREFIX: {
        CLIENT: 'client', // client/{CID}
        OMNI: 'omni',     // omni/{OmniID}
    },
    OMNI_ID: environment.omniId
};

export const MQTT_CONNECTION_OPTIONS: any = {
    hostname: environment.mqtt.hostname,
    port: environment.mqtt.port,
    path: '/ws',
    protocol: environment.mqtt.protocol,
    protocolVersion: 5,
    clean: true,
    connectTimeout: 4000,
    keepalive: 60
};
